<div style="background-color: #F0F8FF; align-content: center; position: relative; min-height: 100px; width: auto;">
  <div *ngIf="initialList ; else elseBlock" style="background-color: #F0F8FF;">
    <!--First Page ria-->
    <div class="resetMarginandPadding row"
      style="background-image: linear-gradient(to right,  #2439de ,#27baed); width: 100%;">
      <table class=" resetMarginandPadding" style="width:100%;">
        <tr class="resetMarginandPadding" style="width: 100%;">
          <th class="resetMarginandPadding" style="width: 50%;">
            <div class="resetMarginandPadding" style="vertical-align: middle; align-content: center;">
              <div
                style=" display: inline; text-align: center; align-content: center; color: white; font-size: 4.5vw; padding-left: 10px;">
                Chat with us!</div>
            </div>
          </th>
          <th style="width:50%" class="resetMarginandPadding">
            <img src="https://www.umfst.ro/fileadmin/templates/images/logo_new/logo_ro_white_new.png" style=" align-content: stretch; padding-right: 10px; padding-top: 5px; padding-bottom: 5px;
              width: 100%;height: auto;">
          </th>
        </tr>
      </table>
      <table style="border: none;width: 100%;">

        <tr class="resetMarginandPadding" style="width:100%">
          <th class="resetMarginandPadding" style="color: white; width: 80px; text-align:left;">
            <div style="padding-left: 10px;">
              <img
                src="https://images.generated.photos/QaHbCf7SRuFeppnmIBd0tTKzoLAgLPiQYiTkjBwo6IQ/rs:fit:512:512/Z3M6Ly9nZW5lcmF0/ZWQtcGhvdG9zLzA5/OTk5MTcuanBn.jpg"
                style="width: 60px; height: 60px; border-radius: 50%;align-content: left;">
            </div>

          </th>

          <th class="resetMarginandPadding" style="color: white; width: 50%; text-align:left;">
            <i style="font-size: 2.0vh;display: inline; padding-left: 5px;">Hello! I am here to answer your questions about admission at UMFST.</i>
          </th>
          <th class="resetMarginandPadding" style="position: relative;">
            <div class="resetMarginandPadding"
              style="position: absolute;  right: 10px; bottom: 5px; text-align: right;color: white;">
              <i style="font-size: 2.0vh;">Powered by Jacaranda</i>
            </div>
          </th>
        </tr>
      </table>
    </div>
    <div class="resetMarginandPadding row messageDiv" style=" height: 40px;background-color: #F0F8FF;"></div>
    <div class="resetMarginandPadding row messageDiv" style=" width: 100%;">
      <table class="resetMarginandPadding" style="width:100% ;background-color: #F0F8FF;">
        <tr class="resetMarginandPadding" style="height: 80px;">
          <th class="resetMarginandPadding" style="width: 25%;"></th>
          <th class="resetMarginandPadding">
            <i style="font-size: 2.0vh;">   ALEX is not a substitute for your communication with the university. For the latest information, periodically check the university website or contact the secretariat.</i>
          </th>
          <th class="resetMarginandPadding" style="width: 25%;"></th>
        </tr>
      </table>
      <table class="resetMarginandPadding" style="width:100% ;background-color: #F0F8FF;">
        <tr class="resetMarginandPadding" style="align-content: center;align-items: center; height: 80px;">
          <th class="resetMarginandPadding" style="width: 45%;"></th>
          <th class="resetMarginandPadding">
            <button (click)="sendMessage(this.formValue)" ngClass="sendButton"
              style="color: white; width: 200px;height: 60;border-radius: 5px;">
              <i style="font-size: 2.0vh;"> Start chat </i>
            </button>
          </th>
          <th class="resetMarginandPadding" style="width: 45%;"></th>

        </tr>
        <tr class="resetMarginandPadding" style="align-content: center;align-items: center; height: 80px;">
          <th class="resetMarginandPadding" style="width: 45%;"></th>
          <th class="resetMarginandPadding">

          </th>
          <th class="resetMarginandPadding" style="width: 45%;"></th>

        </tr>
      </table>
    </div>
  </div>
  <ng-template #elseBlock>
    <!-- chat aria -->
    <div class="resetMarginandPadding row wave"
      style="background-image: linear-gradient(to right,  #2439de ,#27baed);  width: 100%; position: fixed; top: 0px; z-index: 2;">
      <table class="resetMarginandPadding" style="width:100%;height: 60px;">
        <tr class="resetMarginandPadding" width="100%">
          <th class="resetMarginandPadding" style="width: 70%;">
            <div style="text-align: center;color: white; font-size: 4.5vh;">ALEX</div>
          </th>
          <!--
          <th class="resetMarginandPadding" style="width: 10%;">
            <button (click)="HomeAction()" ngClass="sendButton"
              style="width: 80px;height: 60;border-radius: 5px;background-color: transparent;background-image: none;">
              <i style="font-size: 2.0vh;color: white;"> HOME </i>
            </button>
          </th>
          <th class="resetMarginandPadding" style="width: 10%;">
            <button (click)="FAQAction()" ngClass="sendButton"
              style="width: 80px ;height: 60;border-radius: 5px;background-color: transparent;background-image: none;">
              <i style="font-size: 2.0vh;color: white;"> FAQ </i>
            </button>
          </th>
          <th class="resetMarginandPadding" style="width: 10%;">
            <button (click)="ShareAction()" ngClass="sendButton"
              style="width: 80px;height: 60;border-radius: 5px;background-color: transparent;background-image: none;">
              <i style="font-size: 2.0vh;color: white;"> SHARE </i>
            </button>
          </th>
          -->
        </tr>
      </table>
    </div>
    <div class="resetMarginandPadding" style="height: 100px;"></div>
    <div class="resetMarginandPadding" style="width: 100%;">
      <table style="width: 100%;">
        <ng-container *ngFor="let message of messages | async">
          <div *ngIf="message.sentBy === 'bot'; else elseBlock">
            <tr class="resetMarginandPadding" style="width: 100%;">
              <th class="resetMarginandPadding" style="min-width: 60px;"> <img
                  src="https://images.generated.photos/QaHbCf7SRuFeppnmIBd0tTKzoLAgLPiQYiTkjBwo6IQ/rs:fit:512:512/Z3M6Ly9nZW5lcmF0/ZWQtcGhvdG9zLzA5/OTk5MTcuanBn.jpg"
                  style="width: 40px; height: 40px; border-radius: 50%;margin-left:10px;"></th>
              <th class="resetMarginandPadding" style="width: 100%;">
                <div class=" message resetMarginandPadding botBubble" style="padding-left: 10px;max-width: 90%;"
                  [innerHTML]="parseBody(message.content)"></div>
              </th>
            </tr>
          </div>
          <ng-template #elseBlock>
            <tr class="resetMarginandPadding" style="width: 100%;">
              <th class="resetMarginandPadding" style="width: 100%;">
                <div class="resetMarginandPadding message userBubble" [innerHTML]="message.content"></div>
              </th>
              <th class="resetMarginandPadding" style="min-width: 60px;"> <img src="../../../assets/user.png"
                  style="width: 40px; height: 40px; border-radius: 50%;"></th>
            </tr>
          </ng-template>
          <ng-container *ngFor="let payloadMessage of message.payloadMessages ">
            <div class="parentPayloadMessage">
              <div *ngIf="payloadMessage.payloadType === 'calculator' ; else elseBlock" style="padding-left: 70px;">
              </div>
              <ng-template #elseBlock>
                <tr class="resetMarginandPadding">
                  <th class="resetMarginandPadding">
                    <div>{{ payloadMessage.payloadType }}</div>
                    <button class="payloadMessageChild" [ngClass]="{ 'from': payloadMessage.sentBy === 'bot'}"
                      (click)="sendMessagefromButton(payloadMessage.payloadValue)">
                      {{ payloadMessage.payloadTitle }}
                    </button>
                  </th>
                  <th class="resetMarginandPadding" style="min-width: 60px;"></th>
                </tr>
              </ng-template>
            </div>
          </ng-container>
        </ng-container>
      </table>
    </div>
    <!-- Text Imput Aria -->
    <div class="resetMarginandPadding" style="height: 100px;"></div>
    <div *ngIf="sharePressed; else elseBlock">
      <div class="resetMarginandPadding row messageDiv">
        <table class="resetMarginandPadding"
          style="width:100%; bottom: 0px; position: fixed; background-color: #F0F8FF; padding-bottom: 10px;"
          class="resetMarginandPadding">
          <tr class="resetMarginandPadding">
            <th class="resetMarginandPadding" style="padding-left: 5px;"> <i style="font-size: 2.0vh;"> Enter the email address which you want to receive ALEX URL: </i> </th>
            <th class="resetMarginandPadding"
              style="width: 70px;padding-right: 5px;padding-left: 60px;padding-top: 2px;padding-bottom: 2px;">
              <button (click)="closeShare()" ngClass="sendButton" style="width: 40px;height: 40px;">
                <i style="font-size: 2.0vh;color: white;">X</i>
              </button>
            </th>
          </tr>
          <tr class="resetMarginandPadding" style="width: 100%;">
            <th class="resetMarginandPadding" style="padding-left: 5px;">
              <input [(ngModel)]="emailShareValue" (keyup.enter)="sendMail()" type="text"
                style="
              width: 100%;
                height: 50px;
                font-size: 2.5vh;
                font: 'Calibri Light';
                padding-left: 0px;
                padding-top: 0px;
                padding-right: 0px;
                padding-bottom: 0px; background-color: white; border-width: 2px; border-color: #2439de; margin-bottom: 5px;border-bottom-right-radius: 0px; border-top-right-radius: 0px;">

            </th>
            <th class="resetMarginandPadding" style="width: 70px; align-content: left;">
              <button (click)="sendMail()" ngClass="sendButton"
                style="width: 95%; height: 50px;border-radius: 5px;margin-bottom: 5px ;border-bottom-left-radius: 0px; border-top-left-radius: 0px;">
                <i style="font-size: 2.0vh;color: white;"> SEND </i></button>
            </th>

          </tr>
        </table>
      </div>
    </div>
    <ng-template #elseBlock>
      <div class="resetMarginandPadding row messageDiv">
        <table class="resetMarginandPadding"
          style="width:100%; bottom: 0px; position: fixed; background-color: #F0F8FF; padding-bottom: 5px;"
          class="resetMarginandPadding">
          <tr class="resetMarginandPadding" style="width: 100%;">
            <th class="resetMarginandPadding" style="min-width: 60px;height:50px;align-content: left;padding-left: 5px;">
              <button mat-fab (click)="setSpeak()" ngClass="sendButton"
                style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;border-top-right-radius: 0px; border-bottom-right-radius: 0px; width: 100%;">
                <mat-icon *ngIf="speakEnabled" style="width: 26px;height: 26px;color: white;">sensors</mat-icon>
                <mat-icon *ngIf="!speakEnabled" style="width: 26px;height: 26px;color:white">sensors_off</mat-icon>
              </button>
            </th>
            <th class="resetMarginandPadding" style="min-width: 60px;height:50px;align-content: left;padding-left: 5px;">
              <button mat-fab (click)="startButton($event)" ngClass="sendButton"
                style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;border-top-right-radius: 0px; border-bottom-right-radius: 0px; width: 100%;">
                <mat-icon *ngIf="!recognizing" style="width: 26px;height: 26px;color: white;">mic</mat-icon>
                <mat-icon *ngIf="recognizing" style="width: 26px;height: 26px;color:white">stop</mat-icon>
              </button>
            </th>
            <th class="resetMarginandPadding" style="width:85%">
              <input [(ngModel)]="formValue" (keyup.enter)="sendMessage(this.formValue)" type="text"
                style="
                height: 50px;
                font-family: 'Calibri Light';
                width: 100%;
                font-size: 2.5vh;
                padding-left: 0px;
                padding-top: 0px;
                padding-right: 0px; border-radius: 0px;
                padding-bottom: 0px; background-color: white; border-width: 1px; border-color: #2439de; margin-bottom: 5px;margin-top: 5px;" (click)="resetValue()">

            </th>
            <th class="resetMarginandPadding" style="min-width: 60px; height:50px ;padding-right: 5px;">
              <button (click)="sendMessage(this.formValue)" ngClass="sendButton"
                style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;border-top-right-radius: 0px; border-bottom-right-radius: 0px;  width: 100%;">
                <i class="far fa-paper-plane" style="font-size: 25px;color: white;"></i></button>
            </th>

          </tr>
        </table>
      </div>
    </ng-template>

  </ng-template>
</div>
